export default __webpack_public_path__ + "static/media/calendarShare.812dac0e.svg";